import { useEffect, useState, useCallback } from "react";
import { Search } from "lucide-react";
import api, { fmtDateTime } from "../../lib/api";
import { PageHeader, TableShell, TR, TD, LoadingRows, EmptyState, StatusBadge } from "../../components/Shared";
import { Input } from "../../components/ui/input";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  const [q, setQ] = useState("");

  const load = useCallback(() => { api.get("/admin/audit", { params: { q } }).then((r) => setLogs(r.data)); }, [q]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-audit">
      <PageHeader title="Audit Logs" subtitle="Every important action across the platform." />
      <div className="relative max-w-sm mb-6">
        <Search className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actions or actors…" className="pl-10 h-11 rounded-full" />
      </div>
      {!logs ? <LoadingRows /> : logs.length === 0 ? <EmptyState title="No logs" body="Audit events will appear here." /> : (
        <TableShell testid="audit-table" head={["Time", "Actor", "Role", "Action", "Entity", "Details"]}>
          {logs.map((l) => (
            <TR key={l.id} testid={`audit-row-${l.id}`}>
              <TD className="text-xs text-muted-foreground whitespace-nowrap">{fmtDateTime(l.created_at)}</TD>
              <TD className="text-sm">{l.actor_email}</TD>
              <TD><span className="text-[10px] font-extrabold px-2 py-1 rounded-full border border-border tracking-wide whitespace-nowrap">{l.role}</span></TD>
              <TD><span className="font-mono text-xs font-bold">{l.action}</span></TD>
              <TD className="text-sm">{l.entity}</TD>
              <TD className="text-xs text-muted-foreground max-w-56 truncate">{Object.keys(l.meta || {}).length ? JSON.stringify(l.meta) : "—"}</TD>
            </TR>
          ))}
        </TableShell>
      )}
    </div>
  );
}
